import React from 'react';
import classNames from 'classnames';
import { Icons, PrimaryButton } from '../../../components';
import { isArrayLength } from '../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import { getTalentServiceDescription } from '../../../config/configExtras';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../util/routes';
import { SignatureServiceTypes } from '../../../util/enums';

function SectionEndorsements({ selectedSignatureService, providerServices, title, listing }) {
  const endorsements = isArrayLength(providerServices)
    ? providerServices
        .filter(s => s?.selected)
        .sort((a, b) => {
          // 1. Sort by platform (A → Z)
          const platformCompare = a.platform.localeCompare(b.platform);
          if (platformCompare !== 0) return platformCompare;

          // 2. If same platform, sort by type (A → Z)
          return a.type.localeCompare(b.type);
        })
    : [];
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const listingId = listing?.id?.uuid;
  const navigateToServiceOfferingsPage = endorsement => {
    const { platform, type, price } = endorsement || {};
    const pathname = createResourceLocatorString(
      'ServiceOfferingsPage',
      routeConfiguration,
      { id: listingId, type: SignatureServiceTypes.SOCIAL_MEDIA },
      {}
    );

    history.push({
      pathname,
      state: {
        item: {
          title: type,
          price: price,
          platform,
        },
      },
    });
  };
  return (
    <>
      <div className={css.getCustomVideo}>
        <h2>
          {selectedSignatureService?.title}{' '}
          <FormattedMessage id="SectionEndorsements.from" values={{ title }} />
        </h2>
      </div>
      {isArrayLength(endorsements)
        ? endorsements.map((endorsement, idx) => (
            <div className={css.bookingSec} key={idx}>
              <div className={classNames(css.offerSec, css.withoutIconSec)}>
                <div className={css.offerContent}>
                  <h2>
                    {endorsement?.platform} - {endorsement?.type}
                  </h2>
                  <p>${Number(endorsement?.price).toFixed(2)}</p>
                  <p>
                    {getTalentServiceDescription(`${endorsement?.platform} ${endorsement?.type}`)}
                  </p>
                  <PrimaryButton
                    className={css.bookBtn}
                    type="button"
                    onClick={() => navigateToServiceOfferingsPage(endorsement)}
                  >
                    <Icons name="security" />
                    <FormattedMessage id="SectionEndorsements.buyNow" />
                  </PrimaryButton>
                </div>
              </div>
            </div>
          ))
        : null}
    </>
  );
}

export default SectionEndorsements;
